class ApiClient {
  constructor() {
    // this.baseUrl = "http://127.0.0.1:5000/api"
    // this.baseUrl = "http://192.168.1.123/api"
    this.baseUrl = "/api";
    this.token = localStorage.getItem("auth_token")
    this.onUnauthorized = null
  }

  getToken() {
    return this.token;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseUrl}${endpoint}`

    const headers = {
      "Content-Type": "application/json",
      ...options.headers,
    }

    if (this.token) {
      headers.Authorization = `Bearer ${this.token}`
    }

    try {
      const response = await fetch(url, {
        ...options,
        headers,
      })

      const data = await response.json()

      if (response.status === 401) {
        if (typeof this.onUnauthorized === "function") {
          this.onUnauthorized()
        }
        throw new Error("Unauthorized")
      } else if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`)
      }

      return data
    } catch (error) {
      console.error("API request failed:", error)
      throw error
    }
  }

  // Авторизация
  async login(email, password) {
    const response = await this.request("/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    })

    this.token = response.token
    localStorage.setItem("auth_token", response.token)
    return response
  }

  // Выход
  logout() {
    this.token = null
    localStorage.removeItem("auth_token")
  }

  setUnauthorizedHandler(handler) {
    this.onUnauthorized = handler
  }

  // Получение текущего пользователя
  async getCurrentUser() {
    return this.request("/auth/me")
  }

  // Смена пароля
  async changePassword(newPassword) {
    return this.request("/auth/change-password", {
      method: "POST",
      body: JSON.stringify({ new_password: newPassword }),
    })
  }

  // Администратор: создание преподавателя
  async createTeacher(email, fullName, language) {
    return this.request("/admin/teachers", {
      method: "POST",
      body: JSON.stringify({ email, full_name: fullName, lang: language }),
    })
  }

  // Администратор: получение всех пользователей
  async getAllUsers(role) {
    const params = role ? `?role=${role}` : ""
    return this.request(`/admin/users${params}`)
  }

  // Администратор: блокировка/разблокировка пользователя
  async updateUserStatus(userId, isActive) {
    return this.request(`/admin/users/${userId}/status`, {
      method: "PUT",
      body: JSON.stringify({ is_active: isActive }),
    })
  }

  // Администратор: удаление пользователя
  async deleteUser(userId) {
    return this.request(`/admin/users/${userId}`, {
      method: "DELETE",
    })
  }

  // Администратор: сброс пароля пользователя
  async resetUserPassword(userId, language) {
    return this.request(`/admin/users/${userId}/reset-password`, {
      method: "POST",
      body: JSON.stringify({ lang: language }),
    })
  }

  // Преподаватель: приглашение студента
  async inviteStudent(email, fullName, language) {
    return this.request("/teacher/students", {
      method: "POST",
      body: JSON.stringify({ email, full_name: fullName, lang: language }),
    })
  }

  // Преподаватель: получение студентов
  async getStudents() {
    return this.request("/teacher/students")
  }

  // Преподаватель: блокировка студента
  async blockStudent(studentId) {
    return this.request(`/teacher/students/${studentId}/block`, {
      method: "PUT",
    })
  }

  // Преподаватель: разблокировка студента
  async unblockStudent(studentId) {
    return this.request(`/teacher/students/${studentId}/unblock`, {
      method: "PUT",
    })
  }

  // Преподаватель: удаление студента
  async deleteStudent(studentId) {
    return this.request(`/teacher/students/${studentId}`, {
      method: "DELETE",
    })
  }

  // Преподаватель: сброс пароля студента
  async resetStudentPassword(studentId, language) {
    return this.request(`/teacher/students/${studentId}/reset-password`, {
      method: "POST",
      body: JSON.stringify({ lang: language }),
    })
  }
}

export const apiClient = new ApiClient()
